export const USER_NOTIFICATION_PREFIX = 'whats-new-modal-'
